import React, { useState } from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import Avatar, { AVATAR_PRESETS } from "./Avatar";
import { Check } from "lucide-react";

/**
 * AvatarPicker dialog
 * props: open, onOpenChange, value (current avatar), onSelect(newAvatar), name, lastname
 */
export default function AvatarPicker({ open, onOpenChange, value, onSelect, name = "", lastname = "" }) {
  const [chosen, setChosen] = useState(value || "initials");
  const confirm = () => { onSelect(chosen); onOpenChange(false); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl border-0 max-w-lg" data-testid="avatar-picker">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Scegli il tuo avatar</DialogTitle>
        </DialogHeader>
        <div className="text-sm text-[#555] mb-4">Seleziona uno stile preimpostato oppure usa le tue iniziali.</div>

        <div className="grid grid-cols-4 sm:grid-cols-6 gap-3">
          {/* Initials option */}
          <button
            type="button"
            onClick={() => setChosen("initials")}
            data-testid="avatar-opt-initials"
            className={`relative aspect-square rounded-2xl border-2 transition-all hover:scale-105 ${chosen === "initials" ? "border-[#FF7A29] ring-2 ring-[#FF7A29]/30" : "border-[#EDE5D8]"}`}
          >
            <div className="absolute inset-1.5">
              <Avatar avatar="initials" name={name} lastname={lastname} size={48} className="w-full h-full"/>
            </div>
            {chosen === "initials" && (
              <div className="absolute top-1 right-1 w-5 h-5 rounded-full bg-[#FF7A29] text-white flex items-center justify-center">
                <Check className="w-3 h-3"/>
              </div>
            )}
          </button>

          {AVATAR_PRESETS.map((a) => (
            <button
              key={a.id}
              type="button"
              onClick={() => setChosen(a.id)}
              data-testid={`avatar-opt-${a.id}`}
              title={a.label}
              className={`relative aspect-square rounded-2xl border-2 transition-all hover:scale-105 ${chosen === a.id ? "border-[#FF7A29] ring-2 ring-[#FF7A29]/30" : "border-[#EDE5D8]"}`}
            >
              <div className="absolute inset-1.5">
                <Avatar avatar={a.id} size={48} className="w-full h-full"/>
              </div>
              {chosen === a.id && (
                <div className="absolute top-1 right-1 w-5 h-5 rounded-full bg-[#FF7A29] text-white flex items-center justify-center">
                  <Check className="w-3 h-3"/>
                </div>
              )}
            </button>
          ))}
        </div>

        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-full">Annulla</Button>
          <Button onClick={confirm} data-testid="avatar-save-btn" className="rounded-full bg-[#FF7A29] hover:bg-black">
            Salva avatar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
